/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LegalAccount } from './LegalAccount';
import {
    LegalAccountFromJSON,
    LegalAccountFromJSONTyped,
    LegalAccountToJSON,
} from './LegalAccount';

/**
 * 
 * @export
 * @interface UpdateLegalAccountDetailsOutput
 */
export interface UpdateLegalAccountDetailsOutput {
    /**
     * 
     * @type {LegalAccount}
     * @memberof UpdateLegalAccountDetailsOutput
     */
    account?: LegalAccount;
    /**
     * 
     * @type {Error}
     * @memberof UpdateLegalAccountDetailsOutput
     */
    error?: Error;
}

/**
 * Check if a given object implements the UpdateLegalAccountDetailsOutput interface.
 */
export function instanceOfUpdateLegalAccountDetailsOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateLegalAccountDetailsOutputFromJSON(json: any): UpdateLegalAccountDetailsOutput {
    return UpdateLegalAccountDetailsOutputFromJSONTyped(json, false);
}

export function UpdateLegalAccountDetailsOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLegalAccountDetailsOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'account': !exists(json, 'account') ? undefined : LegalAccountFromJSON(json['account']),
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function UpdateLegalAccountDetailsOutputToJSON(value?: UpdateLegalAccountDetailsOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'account': LegalAccountToJSON(value.account),
        'error': value.error,
    };
}

